import React from "react";
import { GiBottomRight3dArrow } from "react-icons/gi";
import { PhotoProvider, PhotoView } from "react-photo-view";
import "react-photo-view/dist/react-photo-view.css";
import { isImage, isVideo } from "../../utils/commonFunctions";

/**
 * @function DetailCard
 * @description for DetailCard
 * @returns JSX for DetailCard
 */

const DetailCard = ({ label = "N/A", data = "N/A", type = "" }) => {
  return (
    <div
      className={`detail-card ${type === "image" && " mt-2 d-flex align-items-center "}`}
    >
      <p className={`detail-card-label ${type === "image" && ""}`}>{label}</p>
      {type === "image" ? (
        <PhotoProvider>
          <PhotoView key={0} src={data}>
            {isImage(data) ? (
              <img
                src={data}
                alt=""
                className="thumbnail active"
                style={{
                  objectFit: "cover",
                  borderWidth: "1px",
                  height: "120px",
                  width: "120px",
                  borderRadius: "10%",
                }}
              />
            ) : (
              isVideo(data) && (
                <video
                  className="thumbnail active"
                  style={{
                    objectFit: "cover",
                    borderWidth: "1px",
                    height: "120px",
                    width: "120px",
                    borderRadius: "10%",
                  }}
                >
                  <source src={data} />
                </video>
              )
            )}
          </PhotoView>
        </PhotoProvider>
      ) : (
        <p className="label-text detail-card-data ">{data || "N/A"}</p>
      )}
    </div>
  );
};

export default DetailCard;
